import { EntityStore } from '../../../shared/stores/EntityStore';
import {
	action,
	computed,
	makeObservable,
	observable,
	runInAction
} from 'mobx';
import { api } from '../../../shared/api/api';

class IndustryStore extends EntityStore {
	@observable industries = [];

	constructor() {
		super('industries');
		makeObservable(this);
	}

	@computed
	get industryOptions() {
		return this.industries.map(industry => ({
			value: industry.id,
			label: industry.name,
			slug: industry.value
		}));
	}

	@action
	async getIndustries(query = '') {
		const url = this.entityPluralEndpoint + '?q=' + (query || '');
		const result = await api.get(encodeURI(url));
		if (result.status === 'success' && result.data && !query) {
			runInAction(() => {
				this.industries = result.data;
			});
		}
		return result;
	}

	@action
	async loadIndustries() {
		if (this.industries.length) {
			return { status: 'success', data: this.industries };
		}
		return this.getIndustries('');
	}
}

export const industryStore = new IndustryStore();
